export const adjustColor = (color, amount) => {
	const clamp = (val) => Math.min(Math.max(val, 0), 255);

	// Remove the # if present
	color = color.replace('#', '');

	// Convert to RGB
	const num = parseInt(color, 16);
	let r = (num >> 16) + amount;
	let g = ((num >> 8) & 0x00ff) + amount;
	let b = (num & 0x0000ff) + amount;

	// Clamp values and convert back to hex
	const result =
		'#' +
		(0x1000000 + (clamp(r) << 16) + (clamp(g) << 8) + clamp(b))
			.toString(16)
			.slice(1);

	return result;
};
